// extracted by mini-css-extract-plugin
export var icon = "_rd-0";